import Button from 'components/button';
import { dateWordShort } from 'helper/helper';

const ReasonSection = ({ dataCreateMission, setPage }) => {
  const contentMotif = {
    1: (
      <p className="ft-sm break-words">
        <span className="text-gray-900 font-medium">
          Accroissement temporaire d’activité :
        </span>{' '}
        {dataCreateMission.motif?.message}
      </p>
    ),
    2: (
      <>
        <p className="ft-sm">
          <span className="text-gray-900 font-medium">
            En attente de recrutement :
          </span>
        </p>
        <p className="ft-sm">
          <span className="text-gray-700 font-medium">Nom : </span>
          {dataCreateMission.motif?.name}
        </p>
        <p className="ft-sm">
          <span className="text-gray-700 font-medium">Prénom : </span>
          {dataCreateMission.motif?.prenom}
        </p>
        <p className="ft-sm">
          <span className="text-gray-700 font-medium">Date : </span>
          {dateWordShort(dataCreateMission.motif?.date)}
        </p>
      </>
    ),
    3: (
      <>
        <p className="ft-sm">
          <span className="text-gray-900 font-medium">
            Remplacement d’un salarié absent :
          </span>
        </p>
        <p className="ft-sm">
          <span className="text-gray-700 font-medium">Nom : </span>
          {dataCreateMission.motif?.name}
        </p>
        <p className="ft-sm">
          <span className="text-gray-700 font-medium">Prénom : </span>
          {dataCreateMission.motif?.prenom}
        </p>
        <p className="ft-sm">
          <span className="text-gray-700 font-medium">Poste : </span>
          {dataCreateMission.motif?.poste}
        </p>
        <p className="ft-sm break-words">
          <span className="text-gray-700 font-medium">Message : </span>
          {dataCreateMission.motif?.message}
        </p>
      </>
    ),
    4: (
      <>
        <span className="text-gray-900 font-medium">
          Emploi à caractère saisonnier :
        </span>{' '}
        {dataCreateMission.motif?.message}
      </>
    ),
    5: (
      <>
        <span className="text-gray-900 font-medium">
          Emploi à caractère saisonnier :
        </span>{' '}
        {dataCreateMission.motif?.message}
      </>
    ),
  };

  return (
    <div className="mx-6 border-b border-gray-200 py-2">
      <div className="flex justify-between">
        <span className="ft-b text-gray-900 font-medium">
          Raison de l’emploi
        </span>
        <Button color="DEFAULT" size="SM" onClick={() => setPage(2)}>
          Modifier
        </Button>
      </div>
      <div>{contentMotif[dataCreateMission.motif?.type]}</div>
    </div>
  );
};

export default ReasonSection;
